import type { Locale } from "../api/types";
import { chromeLocale } from "../lib/locale-context";

/** The router's error screen (batch 13). Thai kept beside English; rendered English (`chromeLocale`, ruling 2026-10-04). */
const EN = {
  newVersionTitle: "A new version of Giraffe is available",
  newVersionReloading: "Loading the new version…",
  newVersionBody: "This page was opened before Giraffe was updated. Reload to use the new version; nothing you saved is lost.",
  errorTitle: "This page could not be shown",
  errorBody: "Something went wrong while opening this page. Reload to try again.",
  reload: "Reload",
  details: "Details",
};

export type AppErrorTextKey = keyof typeof EN;

export const APP_ERROR_TEXT: Record<Locale, Record<AppErrorTextKey, string>> = {
  en: EN,
  th: {
    newVersionTitle: "Giraffe มีเวอร์ชันใหม่",
    newVersionReloading: "กำลังโหลดเวอร์ชันใหม่…",
    newVersionBody: "หน้านี้เปิดไว้ก่อน Giraffe ได้รับการอัปเดต โหลดหน้าใหม่เพื่อใช้เวอร์ชันใหม่ ข้อมูลที่บันทึกแล้วไม่หาย",
    errorTitle: "แสดงหน้านี้ไม่ได้",
    errorBody: "เกิดข้อผิดพลาดระหว่างเปิดหน้านี้ โหลดหน้าใหม่เพื่อลองอีกครั้ง",
    reload: "โหลดหน้าใหม่",
    details: "รายละเอียด",
  },
};

export function appErrorText(key: AppErrorTextKey, locale?: Locale): string {
  return APP_ERROR_TEXT[chromeLocale(locale)][key];
}
